var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrending = function SvgTrending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.85 0.85L16.29 2.29L11.41 7.17L8.11998 3.88C7.72998 3.49 7.09998 3.49 6.70998 3.88L0.70998 9.89C0.31998 10.28 0.31998 10.91 0.70998 11.3C1.09998 11.69 1.72998 11.69 2.11998 11.3L7.40998 6L10.7 9.29C11.09 9.68 11.72 9.68 12.11 9.29L17.7 3.71L19.14 5.15C19.45 5.46 19.99 5.24 19.99 4.8V0.5C20 0.22 19.78 0 19.5 0H15.21C14.76 0 14.54 0.54 14.85 0.85Z",
    fill: "#FFFFFF"
  })));
};
export default SvgTrending;